import { render, staticRenderFns } from "./TableCooperationAgreements.vue?vue&type=template&id=5e9abc68&"
import script from "./TableCooperationAgreements.vue?vue&type=script&lang=js&"
export * from "./TableCooperationAgreements.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports